import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { courseAfterPaid, dispatchRazorPayStatus, selectIsRoleFlow, selectSkillName, selectTargetRole, selectUserSkillDetails } from '../../../redux/skillSlice'

// Import all components
import CourseIncludes from './components/CourseIncludes'
import WhatYoullLearn from './components/WhatYoullLearn'
import OutcomeSection from './components/OutcomeSection'
import CertificateSection from './components/CertificateSection'
import ProgressBar from '../../../components/ProgressBar'
import { capitalise } from '../../../utilities/constants'
import NewAwardSection from './components/NewAwardSection'
import Faq from './components/Faq'
import MainPricingCard from './components/MainPricingCard'
import { fetchPersonalizedRoles, fetchRazorpayId, fetchUUID, selectUserInfo } from '../../../redux/userInfoSlice'
import { createOrderId, fetchOrderFailed, fetchOrderSucess, setIsPricingPageVisited, unlockCourse } from '../../../redux/newAnalysisSlice'
import { RAZORPAY_KEY } from '../../../config/api_config'
import useRazorpay from 'react-razorpay'
import { toast } from 'react-toastify'
import { fetchSubscriptionStatus, selectSubscriptionStatus } from '../../../redux/subscriptionStatusSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Mixpanel } from '../../../config/Mixpanel'
import constants from '../../../utilities/constants'
import PlacementModal from '../PlacementModal'
import ComparisonTable from './components/ComparisonTable'
import LearnersSection from './components/LearnersSection'
import { selectIsEvenUser } from '../../../redux/onboardingUserDetails'
import CancellationModal from './components/CancellationModal'
import { registerCoreProductPurchase } from '../../../redux/postPurchaseSlice'

const Pricing = () => {
  const navigate = useNavigate()
  const [showSyllabus, setShowSyllabus] = useState(false)
  const [showStickyCTA, setShowStickyCTA] = useState(false)
  const dispatch = useDispatch()
  const Razorpay = useRazorpay();
  const mainCTARef = useRef(null)
  const couponSectionRef = useRef(null)

  // Get data from Redux
  const skillName = useSelector(selectSkillName) || 'Business Analyst'
  const targetRole = useSelector(selectTargetRole)
  const userInfo = useSelector(selectUserInfo);
  const userName = userInfo?.name || ''
  const email = userInfo?.email || ''
  const userPhone = userInfo?.phone || ''
  const firstName = userName.split(' ')[0]
  const subscriptionStatus = useSelector(selectSubscriptionStatus)
  const [isPlacementAddonSelected, setisPlacementAddonSelected] = useState(false)
  const [isProAddonSelected, setisProAddonSelected] = useState(false)
  const [isCouponApplied, setIsCouponApplied] = useState(false)
  const [showPlacementModal, setShowPlacementModal] = useState(false)
  const [isOneTime , setIsOneTime] = useState(false)
  const [showCancellationModal, setShowCancellationModal] = useState(false)
  const [timeLeft, setTimeLeft] = useState(15 * 60)
  const isRoleFlow = useSelector(selectIsRoleFlow);
  const evenUser = useSelector(selectIsEvenUser);
  const skillDetails = useSelector(selectUserSkillDetails)

  const utm_source = skillDetails?.utm_source
  const utm_medium = skillDetails?.utm_medium

  const proAddonDiscountedPrice = useMemo(() => {
    return isProAddonSelected ? 199 : 0
  }, [isProAddonSelected])

  const proAddonOriginalPrice = useMemo(() => {
    return isProAddonSelected ? 499 : 0
  }, [isProAddonSelected])

  // Function to scroll to coupon section
  const scrollToCouponSection = () => {
    if (couponSectionRef?.current) {
      couponSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
    // Also call the highlight function from MainPricingCard
    if (window.scrollToCouponSection) {
      window.scrollToCouponSection()
    }
  }


  const notSubscribedUser = useMemo(() => {
      return subscriptionStatus?.is_locked || (!subscriptionStatus?.is_locked && subscriptionStatus?.type === 'course_purchased')
}, [subscriptionStatus])





const discountedPrice = useMemo(() => {

  const addOnPrice = isPlacementAddonSelected ? 1499 : 0
  const baseDiscountedPrice = evenUser ? 499 : 299;
  const couponDiscount = isCouponApplied ? 100 : 0;

  return baseDiscountedPrice + addOnPrice - couponDiscount + proAddonDiscountedPrice
}, [evenUser, isPlacementAddonSelected, isCouponApplied, proAddonDiscountedPrice])


const originalPrice = useMemo(() => {


  const addOnPrice = isPlacementAddonSelected ? 4999 : 0
  const baseOriginalPrice = 1999;


  return baseOriginalPrice + addOnPrice + proAddonOriginalPrice
}, [isPlacementAddonSelected, proAddonOriginalPrice])



const discountedPriceOddUser = useMemo(() => {

  const addOnPrice = isPlacementAddonSelected ? 1499 : 0
  const baseDiscountedPrice = 299;
 

  return baseDiscountedPrice + addOnPrice + proAddonDiscountedPrice;
}, [isPlacementAddonSelected, proAddonDiscountedPrice])


const originalPriceOddUser = useMemo(() => {


  const addOnPrice = isPlacementAddonSelected ? 4999 : 0
  const baseOriginalPrice = 1999;


  return baseOriginalPrice + addOnPrice + proAddonOriginalPrice
}, [isPlacementAddonSelected, proAddonOriginalPrice])

const discountedPriceWithoutAddon = useMemo(() => {
  const baseDiscountedPrice = evenUser ? 499 : 299;
  const couponDiscount = isCouponApplied ? 100 : 0;

  return baseDiscountedPrice - couponDiscount + proAddonDiscountedPrice
}, [evenUser, isCouponApplied, proAddonDiscountedPrice])


const originalPriceWithoutAddon = useMemo(() => {


  const baseOriginalPrice = 1999;


  return baseOriginalPrice
}, [])





  const originalPriceEvenUser= useMemo(() => {

  const addOnPrice = isPlacementAddonSelected ? 4999 : 0
  const baseOriginalPrice = 1999;


  return baseOriginalPrice + addOnPrice + proAddonOriginalPrice
}, [isPlacementAddonSelected, proAddonOriginalPrice])


const discountedPriceEvenUser = useMemo(() => {
  const baseDiscountedPrice = isOneTime ? 999 : 499;
  const addOnPrice = isPlacementAddonSelected ? 1499 : 0;

  return baseDiscountedPrice + addOnPrice + proAddonDiscountedPrice
}, [isPlacementAddonSelected, isOneTime, proAddonDiscountedPrice])



const originalPriceOneRupee = useMemo(() => {
  const baseOriginalPrice = 1999;
  const addOnPrice = isPlacementAddonSelected ? 4999 : 0;

  return baseOriginalPrice + addOnPrice + proAddonOriginalPrice
}, [isPlacementAddonSelected, proAddonOriginalPrice])

const discountedPriceOneRupee = useMemo(() => {
  const baseDiscountedPrice = 1;
  const addOnPrice = isPlacementAddonSelected ? 1499 : 0;

  return baseDiscountedPrice + addOnPrice + proAddonDiscountedPrice
}, [isPlacementAddonSelected, proAddonDiscountedPrice])


const discountedPriceOneTime = useMemo(() => {
  const baseDiscountedPrice = 999;
  const addOnPrice = isPlacementAddonSelected ? 1499 : 0;
  return baseDiscountedPrice + addOnPrice + proAddonDiscountedPrice
}, [isPlacementAddonSelected, proAddonDiscountedPrice])

const originalPriceOneTime = useMemo(() => {
  const baseOriginalPrice = 1999;
  const addOnPrice = isPlacementAddonSelected ? 4999 : 0;
  return baseOriginalPrice + addOnPrice + proAddonOriginalPrice
}, [isPlacementAddonSelected, proAddonOriginalPrice])

 console.log('notSubscribedUser', notSubscribedUser)
  useEffect(() => {
    dispatch(setIsPricingPageVisited(true))
  }, [dispatch])


  const handleUnlockAccess = () => {
    navigate('/payment')
  }

  const handleViewSyllabus = () => {
    setShowSyllabus(!showSyllabus)
  }

  useEffect(() => {
    if(userInfo?.session_id){
      dispatch(fetchPersonalizedRoles({ session_id: userInfo?.session_id }))
    }
    
    // Track pricing page load
    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_PAGE_LOADED, {
      skill: skillName,
      targetRole: targetRole,
      notSubscribedUser: notSubscribedUser,
      session_id: userInfo?.session_id
    })
  }, [dispatch, userInfo?.session_id, skillName, targetRole, notSubscribedUser])

  // Intersection Observer for sticky CTA
  useEffect(() => {
    const currentRef = mainCTARef.current
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show sticky CTA when main CTA is not in view
        setShowStickyCTA(!entry.isIntersecting)
      },
      {
        root: null,
        rootMargin: '-20px',
        threshold: 0
      }
    )

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [])

  useEffect(() => {
    if (timeLeft <= 0) return

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return 15 * 60;
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])


  const razorpayHandler = async (callback) => {
    try {
      // Track CTA click
      Mixpanel.people.set({
        isSubscribed: !notSubscribedUser
      })
      Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_CTA_CLICKED)

      const addons = [];
      if(isPlacementAddonSelected){
        addons.push("PLACEMENT_BOOTCAMP")
      }
      if(isProAddonSelected){
        addons.push("1_month_pro_subscription")
      }

       if(!notSubscribedUser){

        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_COURSE_UNLOCK_NOW_CLICKED)
        await dispatch(unlockCourse({ session_id: userInfo?.session_id })).unwrap()
        navigate('/onboarding/thank-you')

        return;
       }
       console.log('isCouponApplied', isCouponApplied)
        const orderIdResponse = await dispatch(createOrderId({ session_id: userInfo?.session_id, product_id: "BASE_PERS_SUB1" , addons : addons , is_trial : false})).unwrap()
        console.log("orderIdResponse", orderIdResponse)
        const options = {
            key: RAZORPAY_KEY,
            currency: "INR",
            name: userName,
            description: "Personalise Subscription",
            image: "",
            subscription_id: orderIdResponse?.subscription_id,
            modal: {
                "ondismiss": function () {
                  setShowCancellationModal(true)
                callback()
                }
            },
            handler: (res) => {
              console.log("res-success", res ,
                { session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} }
              )
                getOrderStatusSuccess({ session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} })
                callback();
            },
            prefill: {
                name: userName,
                email: email,
                contact: userPhone,
            },
            notes: {
                address: "Razorpay Corporate Office",
                addons: addons.join(","),
                session_id : userInfo?.session_id
            },
            theme: {
                color: "#26CBA1"
            }
        };
        const rzp1 = new Razorpay(options);
        rzp1.on("payment.failed", function (response) {
            callback()
            setShowCancellationModal(true)
            getOrderStatusFailed({ session_id: userInfo?.session_id, payment_id: response?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: response?.razorpay_signature, errorObj: {} })
        });
        rzp1.open();
    } catch (error) {
        toast.error('Something Went Wrong! Try Again')
    }finally{
        callback()
    } 
}

const getOrderStatusSuccess = async ({ session_id, payment_id, subscription_id, razorpay_signature, errorObj }) => { 

  Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_COURSE_PURCHASE_SUCCESS)
  dispatch(fetchOrderSucess({ session_id, payment_id, subscription_id, razorpay_signature, errorObj }))
  if(isProAddonSelected){
    dispatch(registerCoreProductPurchase({ name: userName, email: email, phone_number: userPhone, razorpay_order_id: subscription_id, razorpay_payment_id: payment_id }))
  }
  navigate('/onboarding/thank-you')
  
}

const getOrderStatusFailed = async ({ session_id, payment_id, subscription_id, razorpay_signature, errorObj }) => {
  Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_COURSE_PURCHASE_FAILED)
  dispatch(fetchOrderFailed({ session_id, payment_id, subscription_id, razorpay_signature, errorObj }))
}


 
console.log('showStickyBar' , showStickyCTA)


const productName = useMemo(() => {
  
  let sentence = isPlacementAddonSelected ? "Placement Support, " : "";

  return (
    sentence +
    `LearnTubeX One Time Purchase @999`
  );
}, [
  isPlacementAddonSelected
]);


const razorpayHandlerEvenUser = async (callback) => {
  try {
    Mixpanel.people.set({
      isSubscribed: !notSubscribedUser
    })
    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_CTA_CLICKED)
    const addons = [];
    if(isPlacementAddonSelected){
      addons.push("PLACEMENT_BOOTCAMP")
    }
    if(isProAddonSelected){
      addons.push("1_month_pro_subscription")
    }

     if(!notSubscribedUser){

      Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_COURSE_UNLOCK_NOW_CLICKED)
      await dispatch(unlockCourse({ session_id: userInfo?.session_id })).unwrap()
      navigate('/onboarding/thank-you')

      return;
     }

    if(!isOneTime){
    const orderIdResponse = await dispatch(createOrderId({ session_id: userInfo?.session_id, product_id: "BASE_PERS_SUB3" , addons : addons , is_trial : false})).unwrap();
    console.log("orderIdResponse", orderIdResponse)
    const options = {
        key: RAZORPAY_KEY,
        currency: "INR",
        name: userName,
        description: "Personalise Subscription",
        image: "",
        subscription_id: orderIdResponse?.subscription_id,
        modal: {
            "ondismiss": function () {
              setShowCancellationModal(true)
            callback()
            }
        },
        handler: (res) => {
          console.log('afterpay' , res);
          console.log("res-success", res ,
            { session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} }
          )
            getOrderStatusSuccess({ session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} })
            callback();
        },
        prefill: {
            name: userName,
            email: email,
            contact: userPhone,
        },
        notes: {
            address: "Razorpay Corporate Office",
            addons: addons.join(","),
            session_id : userInfo?.session_id
        },
        theme: {
            color: "#26CBA1"
        }
    };
    const rzp1 = new Razorpay(options);
    rzp1.on("payment.failed", function (response) {
        callback()
        setShowCancellationModal(true)
        getOrderStatusFailed({ session_id: userInfo?.session_id, payment_id: response?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: response?.razorpay_signature, errorObj: {} })
    });
    rzp1.open();
    }
    else{


      const uuidResponse = await dispatch(
        fetchUUID({
          name : userName,
          email : email,
          phone_number: userPhone,
          skill_name: skillName,
          medium: utm_medium,
          source: utm_source,
        })
      ).unwrap();

      console.log('uuidResponse', uuidResponse)

      const razorpayOrderId = await dispatch(
        fetchRazorpayId({
          uid: uuidResponse?.uuid,
          amount: discountedPriceEvenUser,
          product_name: productName,
        })
      ).unwrap();

      console.log('razorpayOrderId', razorpayOrderId)

      const options = {
        key: RAZORPAY_KEY,
        currency: "INR",
        name: userName,
        description: `Single Personalise Course Purchased`,
        image: "",
        order_id: razorpayOrderId?.razorpay_order_id,
        modal: {
          "ondismiss": function () {
            setShowCancellationModal(true)
          }
        },
        handler: (res) => {
          console.log('afterpay' , res);
          getOrderStatusSuccessEvenUser({ session_id : userInfo?.session_id, user_id : uuidResponse?.uuid, subject_name : skillName , razorpay_payment_id: res?.razorpay_payment_id, razorpay_order_id: res?.razorpay_order_id});
        },
        prefill: {
          name: userName,
          email: email,
          contact: userPhone,
        },
        notes: {
          address: "Razorpay Corporate Office",
          session_id : userInfo?.session_id,
          addons: addons.join(","),
        },
        theme: {
          color: "#26CBA1",
        },
      };
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        setShowCancellationModal(true)
        getOrderStatusFailedEvenUser(response, uuidResponse?.uuid);
      });
      rzp1.open();

    }
  } catch (error) {
    toast.error('Something Went Wrong! Try Again')
  }
  finally{
    callback()
  }
}

const getOrderStatusSuccessEvenUser = async ({ session_id, user_id, subject_name, razorpay_payment_id, razorpay_order_id }) => {
  console.log('getOrderStatusSuccessEvenUser', { session_id, user_id, subject_name })
  Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_COURSE_PURCHASE_SUCCESS)
  dispatch(courseAfterPaid({ session_id, user_id, subject_name }))
  if(isProAddonSelected){
    dispatch(registerCoreProductPurchase({ name: userName, email: email, phone_number: userPhone, razorpay_order_id: razorpay_order_id, razorpay_payment_id: razorpay_payment_id }))
  }
  navigate('/onboarding/thank-you')
}

const getOrderStatusFailedEvenUser = async (response, uuid) => {
Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_COURSE_PURCHASE_FAILED)
  dispatch(
    dispatchRazorPayStatus({
      uuid: uuid,
      payment_id: response?.error?.metadata?.payment_id,
      order_id: response?.error?.metadata?.order_id,
      isError: true,
      razorpay_signature: "",
      errorObj: { ...response?.error },
    })
  )

}



const razorpayHandlerOddUser = async (callback) => {
  try {
    // Track CTA click
    Mixpanel.people.set({
      isSubscribed: !notSubscribedUser
    })
    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_CTA_CLICKED)

     if(!notSubscribedUser){

      Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_COURSE_UNLOCK_NOW_CLICKED)
      await dispatch(unlockCourse({ session_id: userInfo?.session_id })).unwrap()
      navigate('/onboarding/thank-you')

      return;
     }
     console.log('isCouponApplied', isCouponApplied)
      const orderIdResponse = await dispatch(createOrderId({ session_id: userInfo?.session_id, product_id: "BASE_PERS_SUB1" , addons : isPlacementAddonSelected ? ["PLACEMENT_BOOTCAMP"] : [] , is_trial : true})).unwrap()
      console.log("orderIdResponse", orderIdResponse)
      const options = {
          key: RAZORPAY_KEY,
          currency: "INR",
          name: userName,
          description: "Personalise Subscription",
          image: "",
          subscription_id: orderIdResponse?.subscription_id,
          modal: {
              "ondismiss": function () {
                setShowCancellationModal(true)
              callback()
              }
          },
          handler: (res) => {
            console.log("res-success", res ,
              { session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} }
            )
              getOrderStatusSuccess({ session_id: userInfo?.session_id, payment_id: res?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: res?.razorpay_signature, errorObj: {} })
              callback();
          },
          prefill: {
              name: userName,
              email: email,
              contact: userPhone,
          },
          notes: {
              address: "Razorpay Corporate Office",
              addons: isPlacementAddonSelected ? "PLACEMENT_BOOTCAMP" : "",
              session_id : userInfo?.session_id
          },
          theme: {
              color: "#26CBA1"
          }
      };
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function (response) {
          callback()
          setShowCancellationModal(true)
          getOrderStatusFailed({ session_id: userInfo?.session_id, payment_id: response?.razorpay_payment_id, subscription_id: orderIdResponse?.subscription_id, razorpay_signature: response?.razorpay_signature, errorObj: {} })
      });
      rzp1.open();
  } catch (error) {
      toast.error('Something Went Wrong! Try Again')
  }finally{
      callback()
  } 
}
  
  return (
    <div className='mt-8 w-full md:max-w-[45rem] flex-1 mx-auto px-4 pb-4 lg:pb-6 lg:px-6 text-white relative flex flex-col justify-between items-center flex-1'>
      {/* Progress bar and step indicator */}
      <ProgressBar
        currentStep={isRoleFlow ? 8 : 6}
        totalSteps={isRoleFlow ? 8 : 6}
        stepText={`Step ${isRoleFlow ? 8 : 6}/${isRoleFlow ? 8 : 6} to  ${targetRole ? 'becoming ' + targetRole : 'mastering ' + capitalise(skillName)}`}
      />

      <h1 className='w-full mt-4 mb-4 bg-gradient-to-r from-white to-[#FFE994] bg-clip-text text-transparent font-bold text-[1.75rem] leading-[130%] capitalize'>
        {firstName}, your fastest path to mastering <span className='italic'> {capitalise(skillName)} </span>
      </h1>

      {/* Header Section */}
      <MainPricingCard
        mainCTAref={mainCTARef}
        onUnlockAccess={handleUnlockAccess}
        onViewSyllabus={handleViewSyllabus}
        showSyllabus={showSyllabus}
        notSubscribedUser={notSubscribedUser}
        razorpayHandler={razorpayHandler}
        isPlacementAddonSelected={isPlacementAddonSelected}
        setisPlacementAddonSelected={setisPlacementAddonSelected}
        isProAddonSelected={isProAddonSelected}
        setisProAddonSelected={setisProAddonSelected}
        discountedPrice={discountedPrice}
        originalPrice={originalPrice}
        setShowPlacementModal={setShowPlacementModal}
        showPlacementModal={showPlacementModal}
        isCouponApplied={isCouponApplied}
        setIsCouponApplied={setIsCouponApplied}
        couponSectionRef={couponSectionRef}
        discountedPriceWithoutAddon={discountedPriceWithoutAddon}
        originalPriceWithoutAddon={originalPriceWithoutAddon}
        isOneTime={isOneTime}
        setIsOneTime={setIsOneTime}
        originalPriceEvenUser={originalPriceEvenUser}
        discountedPriceEvenUser={discountedPriceEvenUser}
        razorpayHandlerEvenUser={razorpayHandlerEvenUser}
        originalPriceOneRupee={originalPriceOneRupee}
        discountedPriceOneRupee={discountedPriceOneRupee}
        razorpayHandlerOddUser={razorpayHandlerOddUser}
        timeLeft={timeLeft}
        discountedPriceOneTime={discountedPriceOneTime}
        originalPriceOneTime={originalPriceOneTime}
        discountedPriceOddUser={discountedPriceOddUser}
        originalPriceOddUser={originalPriceOddUser}

      />

      {/* Inline Syllabus Section */}
      {/* {showSyllabus && (
        <InlineSyllabus />
      )} */}

      {/* Main Content Sections */}
      <div className="w-full mt-12 flex flex-col gap-[40px] items-start relative shrink-0 ">

        {/* This Course Includes & What You'll Be Able To Do */}
        <div className="flex flex-col gap-[32px] items-start relative shrink-0 w-full">
          <CourseIncludes />
          <WhatYoullLearn />
        </div>

        {/* Your Outcome In 4 Weeks */}
        <OutcomeSection skillName={skillName} />

        {/* Certificate Section */}
        <CertificateSection skillName={skillName} />
      </div>

      <div className='w-full mt-12'>
        <LearnersSection />
      </div>
      <div className='w-full mt-12'>
        <ComparisonTable />
      </div>
      <div className='w-full mt-12'>
        <NewAwardSection />
      </div>
      <div className='w-full mt-12'>
        <h2 className="text-[24px] font-semibold text-left mb-4">Frequently Asked Questions</h2>
        <Faq />
      </div>
      <div className='w-full h-[70px]'></div>
      <PlacementModal isOpen={showPlacementModal} setIsOpen={setShowPlacementModal}/>

      {/* Bottom Sticky CTA */}
      {showStickyCTA && (
        <div className='sticky bottom-0 z-[99999999999999999] w-[calc(100%+36px)]  bg-[#013965] p-3 flex flex-col gap-1 items-center relative shrink-0 w-full'>
          <button
                  onClick={() => {
                    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PRICING_STICKY_CTA_CLICKED)

                    Mixpanel.people.set({
                      isSubscribed: !notSubscribedUser
                    })
                    if(evenUser){
                      razorpayHandlerEvenUser(() => { })
                      return;
                    }
                  
                    razorpayHandler(() => { })
                    return;
                  }}
                  className="bg-[#7fc241] border-[#8bd845] border-b-2 border-l-2 border-r-2 border-solid content-stretch flex flex-col h-[52px] items-center justify-center p-[12px] relative rounded-[12px] shrink-0 w-full hover:bg-[#6ba836] transition-colors"
                  data-node-id="1641:11000"
                >
                  {notSubscribedUser ? <div className="content-stretch flex gap-[8px] items-center relative shrink-0" data-node-id="1641:11001">
                    <div className="flex flex-col font-['Inter:Semi_Bold',sans-serif] font-semibold justify-center items-center gap-1 leading-[0] not-italic relative shrink-0 text-[#121212] text-[16px] text-center whitespace-nowrap" data-node-id="1641:11002">
                      <p className="leading-none">{evenUser ? 'Start My Personalised Course' : 'Start My Personalised Course'}<FontAwesomeIcon icon={faArrowRight} size='xs' className='ml-1' /></p>
                       {evenUser ? (isPlacementAddonSelected ?<span className='mt-1.5 text-[10px] text-[#121212] font-light'> <span>Pay Just:</span> <span className='font-semibold'>₹{evenUser ? discountedPriceEvenUser : discountedPriceOneRupee}</span></span> : <span className='mt-1.5 text-[10px] text-[#121212] font-light'> <span>Pay Just:</span> <span className='font-semibold'>₹{evenUser ? discountedPriceEvenUser : discountedPriceOneRupee}{!isOneTime && !isProAddonSelected && !isPlacementAddonSelected && '/mo'}</span></span>) : (
                         isPlacementAddonSelected || isProAddonSelected ? <span className='mt-1.5 text-[10px] text-[#121212] font-light'> <span>Pay Just:</span> <span className='font-semibold'>₹{discountedPriceOddUser}</span></span> :  <span className='mt-1.5 text-[10px] text-[#121212] font-light'> <span>Pay Just:</span> <span className='font-semibold'>₹{discountedPriceOddUser}{ '/mo'}</span> <span className='text-black'></span></span>
                       )}
                    </div>
                  </div> : 
                  
                  
                  <div className="content-stretch flex gap-[8px] items-center relative shrink-0" data-node-id="1641:11001">
                    <div className="flex flex-col font-['Inter:Semi_Bold',sans-serif] font-semibold justify-center items-center gap-1 leading-[0] not-italic relative shrink-0 text-[#121212] text-[16px] text-center whitespace-nowrap" data-node-id="1641:11002">
                      <p className="leading-none">Unlock Personalise Course <FontAwesomeIcon icon={faArrowRight} size='xs' /></p>
                    </div>
                  </div>
                  }
                </button>
                <div className="content-stretch flex gap-[8px] items-center justify-center relative shrink-0 w-full whitespace-nowrap" data-node-id="1641:11004">
                <div className="flex flex-col font-['Inter:Italic',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[12px] text-[rgba(255,255,255,0.5)] text-center" data-node-id="1641:11011">
                    <p className="leading-none">{evenUser ? 'Unlimited access' : 'No hidden charges'}</p>
                  </div>
                  <div className="flex flex-col font-['Inter:Italic',sans-serif] font-normal italic justify-center leading-[0] relative shrink-0 text-[12px] text-[rgba(255,255,255,0.5)] text-center" data-node-id="1641:11010">
                    <p className="leading-none">•</p>
                  </div>
                  <div className="flex flex-col font-['Inter:Italic',sans-serif] font-normal  justify-center leading-[0] relative shrink-0 text-[12px] text-[rgba(255,255,255,0.5)] text-center" data-node-id="1641:11011">
                    <p className="leading-none">{evenUser ? 'Cancel anytime' : 'Cancel anytime'} </p>
                  </div>
                </div>
        </div>
      )}
    {showCancellationModal && <CancellationModal isOpen={showCancellationModal} setIsOpen={setShowCancellationModal} userName={userName} timeLeft={timeLeft}
    isEvenUser={evenUser} isPlacementAddonSelected={isPlacementAddonSelected} discountedPriceEvenUser={discountedPriceEvenUser} isOneTime={isOneTime}
    razorpayHandlerEvenUser={razorpayHandlerEvenUser}
    discountedPriceOneRupee={discountedPriceOneRupee}
    razorpayHandler={razorpayHandler}
    discountedPriceOddUser={discountedPriceOddUser}
    originalPriceOddUser={originalPriceOddUser}
    isProAddonSelected={isProAddonSelected}
    />}
    </div>
  )
}

export default Pricing